






import { Component, Vue } from 'vue-property-decorator'
import { ICellRendererComp, ICellRendererParams } from 'ag-grid-community'

@Component
export default class LolthQtyDetailsCellRenderer extends Vue implements ICellRendererComp {
  private params!: ICellRendererParams
  private mValue: any = null

  get value(): { [key: string]: number} {
    return this.mValue || []
  }

  getGui(): HTMLElement {
    return document.createElement('div')
  }

  created() {
    this.refresh(this.params)
  }

  refresh(params: ICellRendererParams): boolean {
    this.mValue = params.value
    return true
  }
}
